import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';

export interface MediaAnalyticsInstance {
	mediaId: number;
	userId: number;
	lastPlayTime: number | null;
	totalPlayTime: number;
	playCount: number;
}

export interface MediaAnalyticsRequest {
	media_id: number;
	user_id: number;
	play_count: number;
	play_duration: number;
	context: null;
}

@Injectable({
	providedIn: 'root'
})
export class NgxMediaAnalyticsService {
	private readonly analyticsInstances: Map<string, MediaAnalyticsInstance> = new Map();

	constructor (private readonly http: HttpClient) {}

	public save (payload: MediaAnalyticsRequest): Observable<void> {
		return this.http.post<void>(
			`${clientSettings.GoReactV2API}/media/${payload.media_id}/media-analytics`,
			payload
		);
	}

	public createInstance (mediaId: number, userId: number): string {
		const instanceId = `${mediaId}-${userId}`;
		this.analyticsInstances.set(instanceId, {
			mediaId,
			userId,
			lastPlayTime: null,
			totalPlayTime: 0,
			playCount: 0
		});
		return instanceId;
	}

	public getInstance (instanceId: string): MediaAnalyticsInstance | undefined {
		return this.analyticsInstances.get(instanceId);
	}

	public removeInstance (instanceId: string): void {
		this.analyticsInstances.delete(instanceId);
	}

	public setStart (instanceId: string, time: number): void {
		const instance = this.getInstance(instanceId);
		if (instance) {
			instance.lastPlayTime = time;
		}
	}

	public incrementPlayCount (instanceId: string): void {
		const instance = this.getInstance(instanceId);
		if (instance) {
			instance.playCount++;
		}
	}

	public setStop (instanceId: string, time: number): void {
		const instance = this.getInstance(instanceId);
		if (instance && instance.lastPlayTime !== null) {
			const delta = time - instance.lastPlayTime;
			if (delta > 0) {
				instance.totalPlayTime += delta;
			}
			instance.lastPlayTime = null;
		}
	}

	public saveInstance (instanceId: string): void {
		const instance = this.getInstance(instanceId);
		if (instance && instance.totalPlayTime > 0) {
			this.save({
				context: null,
				play_duration: Math.round(instance.totalPlayTime),
				media_id: instance.mediaId,
				user_id: instance.userId,
				play_count: instance.playCount
			}).subscribe();
		}
	}
}
